import axios from 'axios'
import { showToast } from 'vant'
import CryptoJS from 'crypto-js'
import store from '@/store'
import Aces from '@/uilts/Aces'

// 创建axios实例
const service = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded' // 设置默认的 Content-Type
    },
    timeout: 5000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        showToast(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const showTip = response.config.showTip !== false
        let res
        try {
            res = JSON.parse(Aces.Decrypt(response.data))
        } catch (e) {
            // 部分接口（wxConfig/miniUrlLink/miniUrlScheme 等）响应为明文 JSON，解密失败时回退按明文解析
            try {
                res = typeof response.data === 'object' ? response.data : JSON.parse(response.data)
            } catch (e2) {
                res = null
            }
        }
        if (!res) {
            showToast('数据解析失败')
            return false
        }
        if (res.code == -1) {
            if (showTip) {
                showToast(res.msg)
            }
            return false
        } else if (res.code == 660) {
            localStorage.removeItem('token')
            localStorage.removeItem('uuid')
            localStorage.removeItem('nickName')
            showToast('请先登录')
            setTimeout(() => {
                window.location.reload()
            }, 1000)
            return false
        }
        return res
    },
    error => {
        if (error.response) {
            const res = error.response.data
            // 404/500 等情况 res.msg 往往不存在，带上 HTTP 状态码方便定位（也避免空黑 toast）
            const msg = (res && res.msg) ? res.msg : ('HTTP ' + error.response.status)
            return Promise.reject(new Error(msg))
        }
        return Promise.reject(new Error('网络异常'))
    }
)

// 封装请求方法
function intercept(url, params, showTip = true) {
    return service.post(url, params, { showTip }).then(response => {
        return response
    }).catch(error => {
        if (showTip) {
            showToast(error.message || '网络异常')
        }
        throw error
    })
}

// 封装请求方法（上传）
function interceptUpload(url, params, processedParams) {
    for (const i in processedParams) {
        params.append(i, processedParams[i])
    }
    return axios.post(url, params, {
        headers: {
            'Content-Type': 'multipart/form-data' // 设置默认的 Content-Type
        },
        timeout: 5000 // 请求超时时间
    }).then(response => {
        const res = response.data
        if (res.code == -1) {
            showToast(res.msg)
            return false
        } else if (res.code == 660) {
            localStorage.removeItem('token')
            localStorage.removeItem('uuid')
            localStorage.removeItem('nickName')
            window.location.reload()
            return false
        }
        return res
    }).catch(error => {
        showToast(error.msg)
        throw error
    })
}

export {
    intercept,
    interceptUpload
}